import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { NO_RESULTS_FOUND_MSG } from '../../../constants/search-messages';
export const AddressesCount = ({ count, isFromSearch, }) => {
    if (Number.isNaN(count) || (count === 0 && !isFromSearch))
        return null;
    const getCounterText = () => {
        if (count === 0 && isFromSearch) {
            return NO_RESULTS_FOUND_MSG.message;
        }
        if (isFromSearch) {
            return `${count} ${count === 1 ? 'result' : 'results'}`;
        }
        return count === 1 ? `${count} address` : `${count} addresses`;
    };
    return (React.createElement(Typography, { height: "normal", weight: "bold", variant: "body-base" }, getCounterText()));
};
